var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavHistory = function SvgNavHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Nav_History_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.748 21c-2.459 0-4.766-.92-6.515-2.604l1.14-1.103c1.433 1.381 3.347 2.144 5.375 2.144 4.208 0 7.642-3.33 7.642-7.425 0-4.094-3.422-7.45-7.642-7.45-4.22 0-7.643 3.344-7.643 7.438v.085h1.927L4.51 15.149 2 12.085h1.496V12c0-4.966 4.157-9 9.252-9C17.843 3 22 7.034 22 12s-4.145 9-9.252 9Zm-.837-8.649.038-5.075h1.61v4.3l2.357 1.865-1 1.224-2.992-2.326-.013.012Z",
    fill: "#666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Nav_History_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 3)",
    d: "M0 0h20v18H0z"
  })))));
};
export default SvgNavHistory;